import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SiteStore } from '@core/site/site.store';

export const bookingModuleGuard = () => {
  const site = inject(SiteStore);
  const router = inject(Router);
  if (!site.showBookingModule()) {
    return router.createUrlTree(['/']);
  }
  return true;
};
